import React, { useState, useEffect } from "react";
import { Image, Row, Col, Button, Modal } from "react-bootstrap";
import Axios from "axios";
import * as CurrencyMethods from "../../../../../admin/files/currencyMethods";
import { useNavigate } from "react-router-dom";
import { isBrowser } from "react-device-detect";

//STYLES
import * as PrintingProgressItemStyles from "../../styles/yourOrders/printingProgressItem";

function PrintProgressItem(props) {
    const [depositModal, setDepositModal] = useState({
        open: false
    });

    const [prices, setPrices] = useState({});

    useEffect(() => {
        setPrices({
            fullPriceWhenOrdered: props.mainItem.fullPriceWhenOrdered,
            depositPriceWhenOrdered: props.mainItem.depositPriceWhenOrdered
        });
    }, []);

    function handleDepositModalClose() {
        setDepositModal((prevState) => {
            return { ...prevState, open: false };
        });
    }

    const itemsDisplay = (
        <div>
            <Row>
                <Col>
                    {props.mainItem.quantity == 1 ? (
                        <div>
                            <Item fe={"1"} mainItem={props.mainItem} extraItem={props.mainItem} quantityOfProducts={false} reload={props.reload} />
                        </div>
                    ) : (
                        <div>
                            <Item
                                fe={"2"}
                                mainItem={props.mainItem}
                                extraItem={props.mainItem}
                                quantityOfProducts={true}
                                productIndex={"1"}
                                totalProducts={props.mainItem.quantity}
                                reload={props.reload}
                            />
                            {props.extraItems.map((item, index) => {
                                console.log(props.mainItem);
                                return (
                                    <div key={index}>
                                        <hr />
                                        <Item
                                            fe={"3"}
                                            mainItem={props.mainItem}
                                            extraItem={item}
                                            quantityOfProducts={true}
                                            productIndex={index + 2}
                                            totalProducts={props.mainItem.quantity}
                                            reload={props.reload}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </Col>
            </Row>
        </div>
    );

    const browserDisplay = (
        <div style={PrintingProgressItemStyles.body}>
            <Row>
                <Col md="auto">
                    <Image
                        src={`/content/3dPrintingShop/products/${props.mainItem.itemDetails.uuid.toString()}/${props.mainItem.itemDetails.mainImage}`}
                        style={PrintingProgressItemStyles.image}
                    />
                </Col>
                <Col>
                    <Row>
                        <Col>
                            <Row>
                                <Col>
                                    <strong>Name:</strong> {props.mainItem.itemDetails.title} <br />
                                    {props.mainItem.designElement != "---" && (
                                        <div>
                                            <strong>Design Element:</strong> {props.mainItem.designElement}
                                        </div>
                                    )}
                                </Col>
                                <Col>
                                    {props.mainItem.customItem == "true" && (
                                        <div>
                                            <strong style={PrintingProgressItemStyles.customTitle}>Customisation</strong>
                                            {props.mainItem.itemDetails.customItems.map((field, index) => {
                                                if (field.type == "text" || field.type == "dColour") {
                                                    return (
                                                        <div key={index}>
                                                            {field.fieldName}: {field.fieldValue}
                                                        </div>
                                                    );
                                                }
                                            })}
                                            {props.mainItem.itemDetails.customColours && (
                                                <div>
                                                    <br />
                                                    <strong>Colours:</strong>
                                                    {props.mainItem.itemDetails.customItems.map((field, index) => {
                                                        if (field.type == "colour") {
                                                            return (
                                                                <div key={index}>
                                                                    {field.fieldName}: {field.fieldValue}
                                                                </div>
                                                            );
                                                        }
                                                    })}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </Col>
                            </Row>
                            <br />
                            {itemsDisplay}
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );

    const mobileDisplay = (
        <div style={PrintingProgressItemStyles.mobile_body}>
            <div style={PrintingProgressItemStyles.flexRow}>
                <div style={PrintingProgressItemStyles.mobile_imageContainer}>
                    <Image
                        src={`/content/3dPrintingShop/products/${props.mainItem.itemDetails.uuid.toString()}/${props.mainItem.itemDetails.mainImage}`}
                        style={PrintingProgressItemStyles.image}
                    />
                </div>
                <div style={PrintingProgressItemStyles.mobile_infoContainer}>
                    <strong>Name:</strong> {props.mainItem.itemDetails.title} <br />
                    {props.mainItem.designElement != "---" && (
                        <div>
                            <strong>Design Element:</strong> {props.mainItem.designElement}
                        </div>
                    )}
                    {props.mainItem.customItem == "true" && (
                        <div>
                            <strong style={PrintingProgressItemStyles.customTitle}>Customisation</strong>
                            {props.mainItem.itemDetails.customItems.map((field, index) => {
                                if (field.type == "text" || field.type == "dColour") {
                                    return (
                                        <div key={index}>
                                            {field.fieldName}: {field.fieldValue}
                                        </div>
                                    );
                                }
                            })}
                            {props.mainItem.itemDetails.customColours && (
                                <div>
                                    <br />
                                    <strong>Colours:</strong>
                                    {props.mainItem.itemDetails.customItems.map((field, index) => {
                                        if (field.type == "colour") {
                                            return (
                                                <div key={index}>
                                                    {field.fieldName}: {field.fieldValue}
                                                </div>
                                            );
                                        }
                                    })}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
            <br />
            {itemsDisplay}
        </div>
    );

    return (
        <div>
            {isBrowser ? browserDisplay : mobileDisplay}
            <br />
            <Modal show={depositModal.open} onHide={handleDepositModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Deposit Item</Modal.Title>
                </Modal.Header>
                <Modal.Body>Do you want to activiate the remaining amount on this model?</Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleDepositModalClose}>No</Button>
                    <Button>Yes</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

function Item(props) {
    const navigate = useNavigate();
    const [addDepositVariant, setAddDepositVariant] = useState("primary");
    /* props
    mainItem
    extraItem
    */
    const [transactionType, setTrasactionType] = useState("");
    const [attention, setAttention] = useState({
        type: "",
        text: "",
        button: ""
    });
    useEffect(() => {
        // console.log(props.extraItem);
        if (props.extraItem.priceStatus == "dp") {
            setTrasactionType("Deposit");
            if (props.extraItem.depositRequested == "true") {
                const rPrice = props.mainItem.fullPriceWhenOrdered - props.mainItem.depositPriceWhenOrdered;
                setTrasactionType("Deposit (Full amount requested)");
                if (props.extraItem.remainingBalanceInBasket) {
                    setAttention({
                        type: "deposit",
                        text: `The full amount of the item has been requested (£${CurrencyMethods.FormatCurrency(
                            rPrice
                        )}) - this item is in your basket`,
                        button: "goToBasket"
                    });
                } else {
                    setAttention({
                        type: "deposit",
                        text: `The full amount of the item has been requested (£${CurrencyMethods.FormatCurrency(rPrice)})`,
                        button: "putInBasket"
                    });
                }
            } else {
                if (props.extraItem.latestMessage != "") {
                    setAttention({
                        type: "messageLog",
                        text: props.extraItem.latestMessage,
                        button: ""
                    });
                }
            }
        } else {
            setTrasactionType("Full Price");
            if (props.extraItem.latestMessage != "") {
                setAttention({
                    type: "messageLog",
                    text: props.extraItem.latestMessage,
                    button: ""
                });
            }
        }
    }, [props]);

    function handleAddDepositToBasket(mainItem, extraItem) {
        const customData = [];
        console.log(mainItem);
        if (mainItem.customItem == "true") {
            for (const [index, file] of Object.entries(mainItem.itemDetails.customItems)) {
                customData.push({
                    fieldName: file.fieldName,
                    value: file.fieldValue
                });
            }
        }

        const data = {
            userID: mainItem.userID,
            productCode: mainItem.itemDetails.productCode,
            quantity: 1,
            priceStatus: "dpr",
            customItem: mainItem.customItem.toString(),
            customData: customData,
            linkedToOrderItemUUID: extraItem.uuid
        };

        Axios.post("/pods/3dPrintingShop/frontEnd/addProductToBasket", data)
            .then((res) => {
                const resData = res.data;
                if (resData.error == "null") {
                    setAddDepositVariant("success");
                    setTimeout(() => {
                        setAddDepositVariant("primary");
                        props.reload();
                    }, 1000);
                }
            })
            .catch((err) => console.log(err));
    }

    function navigateToBasket() {
        navigate("/basket");
    }

    const browserDisplay = (
        <div>
            <Row>
                <Col>
                    {props.quantityOfProducts && (
                        <Row>
                            <Col style={PrintingProgressItemStyles.columnRight}>
                                <strong>
                                    {props.productIndex} of {props.totalProducts}
                                </strong>
                            </Col>
                        </Row>
                    )}

                    <Row>
                        <Col>
                            <strong>Transaction Type: </strong>
                            {transactionType}
                        </Col>
                    </Row>
                    <Row style={PrintingProgressItemStyles.modelAmounts}>
                        <Col>
                            <strong>Total Models:</strong> {props.extraItem.totalModels}
                        </Col>
                        <Col>
                            <strong>Models Built:</strong> {props.extraItem.totalBuilt}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div style={PrintingProgressItemStyles.progressArea}>
                                <div style={PrintingProgressItemStyles.progressBarBack}>
                                    <div
                                        style={{
                                            ...PrintingProgressItemStyles.progressBarFront,
                                            width: `${props.extraItem.progress}%`
                                        }}
                                    ></div>
                                </div>
                                {props.extraItem.progress}%
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col>
                    {attention.text != "" && (
                        <div>
                            <Row>
                                <Col sm="auto">
                                    <strong style={PrintingProgressItemStyles.redText}>Attention: </strong>
                                </Col>
                                <Col>
                                    {attention.type == "deposit" && (
                                        <div>
                                            <strong>{attention.text}</strong> <br />
                                            {attention.button == "putInBasket" && (
                                                <Button
                                                    variant={addDepositVariant}
                                                    onClick={handleAddDepositToBasket.bind(this, props.mainItem, props.extraItem)}
                                                >
                                                    Add amount to basket
                                                </Button>
                                            )}
                                            {attention.button == "goToBasket" && <Button onClick={navigateToBasket}>Go to Basket</Button>}
                                        </div>
                                    )}
                                    {attention.type == "messageLog" && (
                                        <div>
                                            <strong>Message:</strong>
                                            <br />
                                            {attention.text}
                                        </div>
                                    )}
                                </Col>
                            </Row>
                        </div>
                    )}
                </Col>
            </Row>
        </div>
    );

    const mobileDisplay = (
        <div style={PrintingProgressItemStyles.mobile_itemBody}>
            {props.quantityOfProducts && (
                <div style={PrintingProgressItemStyles.columnRight}>
                    <strong>
                        {props.productIndex} of {props.totalProducts}
                    </strong>
                </div>
            )}
            <div>
                <strong>Transaction Type: </strong>
                {transactionType}
            </div>
            <div style={PrintingProgressItemStyles.flexRow}>
                <div style={PrintingProgressItemStyles.mobile_totalModels}>
                    <strong>Total Models:</strong> {props.extraItem.totalModels}
                </div>
                <div style={PrintingProgressItemStyles.mobile_totalBuilt}>
                    <strong>Models Built:</strong> {props.extraItem.totalBuilt}
                </div>
            </div>
            <br />
            <div style={PrintingProgressItemStyles.progressArea}>
                <div style={PrintingProgressItemStyles.progressBarBack}>
                    <div
                        style={{
                            ...PrintingProgressItemStyles.progressBarFront,
                            width: `${props.extraItem.progress}%`
                        }}
                    ></div>
                </div>
                {props.extraItem.progress}%
            </div>
            <div>
                {attention.text != "" && (
                    <div>
                        <Row>
                            <Col sm="auto">
                                <strong style={PrintingProgressItemStyles.redText}>Attention: </strong>
                            </Col>
                            <Col>
                                {attention.type == "deposit" && (
                                    <div>
                                        <strong>{attention.text}</strong> <br />
                                        {attention.button == "putInBasket" && (
                                            <Button
                                                variant={addDepositVariant}
                                                onClick={handleAddDepositToBasket.bind(this, props.mainItem, props.extraItem)}
                                            >
                                                Add amount to basket
                                            </Button>
                                        )}
                                        {attention.button == "goToBasket" && <Button onClick={navigateToBasket}>Go to Basket</Button>}
                                    </div>
                                )}
                                {attention.type == "messageLog" && (
                                    <div>
                                        <strong>Message:</strong>
                                        <br />
                                        {attention.text}
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </div>
                )}
            </div>
        </div>
    );

    return <div>{isBrowser ? browserDisplay : mobileDisplay}</div>;
}

export default PrintProgressItem;
